import { ReactComponent as EditIcon } from 'assets/images/icon/edit-icon.svg';
import { ReactComponent as ExclamationMarkIcon } from 'assets/images/icon/exclamation-mark-icon.svg';
import { ReactComponent as PlusIcon } from 'assets/images/icon/plus-icon.svg';
import { ReactComponent as SearchIcon } from 'assets/images/icon/search-icon.svg';
import { AddNewUserForm } from 'components/universal/addNewUser';
import { Button } from 'components/universal/button';
import { DeleteUsersForm } from 'components/universal/deleteUsersForm';
import { EditUserDataForm } from 'components/universal/editUserDataForm';
import { GenerateLoginForm } from 'components/universal/generateLoginForm';
import Heading from 'components/universal/heading';
import { Modal } from 'components/universal/modal';
import { useEffect } from 'react';
import cls from './employeeManagement.module.scss';
import { useEmployees } from './useEmployees';
import { ReactComponent as Arrow } from 'assets/images/contact/arrow-down.svg';
import { AcceptUserModal } from 'components/universal/acceptUserFormModal';


export interface employeesInterface {
    email: string; 
    employee_position_name?: string;
    first_name: string;
    has_elearning_permission: boolean;
    is_admin: boolean;
    is_premium: boolean;
    last_name: string;
    login: string;
    phone: string;
    workplace_address_city?: string;
    workplace_address_number?: string;
    workplace_address_postcode?: string;
    workplace_address_street?: string;
    workplace_name?: string;
    first_login?: boolean;
    id: number;
}

export const EmployeeManagementView = () => {
    const {
        t,
        handleChange,
        showHandle,
        handleCheckboxChange,
        handleToggleAll,
        sendLogins,
        hideModalHandle,
        tooltipRef,
        showTooltip,
        selectedEmployees,
        setShowTooltip,
        searchTerm,
        searchHandle,
        searchRef,
        filteredEmployees,
        generateSingleLoginAndPassword,
        modalType,
        editData,
        deleteUser,
        deleteUsers,
        addNewUserShowPopup,
        adminWorkplaces,
        findWorkplaceId,
        page,
        showMoreEmployees,
        selectedEmployee,
        acceptserShowPopup,
        showFirstLogin, 
        setShowFirstLogin,
        loadMoreIsHide
    } = useEmployees();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
    
            if (tooltipRef.current && tooltipRef.current.contains(target)) return;
    
            if (
                target.closest('button') &&
                target.closest('button')?.querySelector('svg')
            ) return;
    
            setShowTooltip(0);
        };
    
        if (showTooltip !== 0) {
            document.addEventListener('mousedown', handleClickOutside);
        }
    
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showTooltip]);

    return (
        <>
            <Modal className={cls.modal}>
                {modalType === 'generateLogin' && (
                    <GenerateLoginForm users={selectedEmployees} onCancel={hideModalHandle} />
                )}
                 {modalType === 'deleteUser' && (
                    <DeleteUsersForm users={selectedEmployees} onCancel={hideModalHandle} />
                )}
                {modalType === 'editData' && (
                    <EditUserDataForm user={selectedEmployees} workplaceId={findWorkplaceId()} onCancel={hideModalHandle} />
                )}
                {modalType === 'addNewUser' && (
                    <AddNewUserForm workplaceId={adminWorkplaces[0]?.id} onCancel={hideModalHandle} />
                )}
                {modalType === 'acceptUser' && (
                    <AcceptUserModal user={selectedEmployee} onCancel={hideModalHandle} setShowFirstLogin={setShowFirstLogin} />
                )}
            </Modal>

            <div className={cls.container}>
                <header className={cls.header}>
                    <Heading
                        className={cls.heading}
                        headingLevel="h1"
                        headingStyle="h3"
                    >
                        {t('employeeManagement.title')}
                    </Heading>
                    <div className={cls.searchWrapper}>
                        <a className={cls.buttonSearch} onClick={searchHandle}>
                            <SearchIcon />
                        </a>
                        <input
                            type="text"
                            placeholder={t(
                                'employeeManagement.searchPlaceholder'
                            )}
                            value={searchTerm}
                            onChange={handleChange}
                            className={`${cls.inputSearch} px-4 py-2`}
                            ref={searchRef}
                        />
                        <span className={cls.fakeCheckbox}></span>
                    </div>

                    <div className={cls.headerButtonWrapper}>
                        <Button className={cls.addEmployeeButton} onClick={addNewUserShowPopup}>
                            {t('employeeManagement.addEmployeeLabel')}
                            <PlusIcon />
                        </Button>
                    </div>
                </header>
            </div>
            { filteredEmployees && 
                <div className={cls.listCointainer}>
                    <div className={cls.listWrapper}>
                    <ul className={cls.list}>
                        <li className={cls.item}>
                            <div className={cls.employeeColumnName}>
                                <div className={cls.checkboxWrapper}>
                                    <input
                                        type="checkbox"
                                        name="employee"
                                        checked={selectedEmployees.length > 0 ? true : false}
                                        onChange={handleToggleAll}
                                        className={`${cls.checkbox} ${cls.first} ${selectedEmployees.length === filteredEmployees.length && cls.all}`}
                                    />
                                    <span className={cls.fakeCheckbox}></span>
                                </div>
                                <h3>{t('employeeManagement.nameLabel')}</h3>
                            </div>
                            <h3 className={cls.employeeColumnLogin}>
                                {t('employeeManagement.loginLabel')}
                            </h3>
                            <h3 className={cls.employeeColumnNuber}>
                                {t('employeeManagement.numberLabel')}
                            </h3>
                            <h3 className={cls.employeeColumnEdit}>
                                {
                                    filteredEmployees.length > 0 && selectedEmployees.length > 0 && (
                                        <>
                                            <Button className={cls.headerButton} styleType="blue" onClick={sendLogins}>{t('employeeManagement.sendLoginLabel')}</Button>
                                            <Button className={cls.headerButton} styleType="border" onClick={deleteUsers}>{t('employeeManagement.delete')}</Button>
                                        </>
                                    )
                                }
                            </h3>
                        </li>
                        {filteredEmployees.length > 0 ? (
                            filteredEmployees.map((employee, index) => (
                                <li key={`${employee.id}_${employee.first_name}`} className={cls.item} data-id={employee.id}>
                                    <div className={cls.employeeColumnName}>
                                        <div className={cls.checkboxWrapper}>
                                            <input
                                                type="checkbox"
                                                name="employee"
                                                className={cls.checkbox}
                                                checked={selectedEmployees.some(e => e.id === employee.id)}
                                                onChange={() => handleCheckboxChange(employee)}
                                            />
                                            <span
                                                className={cls.fakeCheckbox}
                                            ></span>
                                        </div>
                                        <p>{employee.first_name} {employee.last_name}</p>
                                    </div>
                                    <p className={`${cls.employeeColumnLogin} ${(!employee.login || !employee.email) && cls.empty}`}>
                                        {employee.login || employee.email || <ExclamationMarkIcon />}
                                    </p>
                                    <p className={cls.employeeColumnNuber}>
                                        {employee.phone}
                                    </p>
                                    <div className={cls.employeeColumnEdit}>
                                        {(employee.first_login && showFirstLogin) && (
                                            <a 
                                                className={cls.firstLoginWrapper} 
                                                onClick={() => acceptserShowPopup(employee)}
                                                >
                                                <span className={cls.firstLoginLabel}>
                                                    {t('employeeManagement.firstLoginLabel')}
                                                </span>
                                            </a>
                                        )}
                                        <div 
                                            ref={showTooltip === employee.id ? tooltipRef : null}
                                            className={`${cls.tooltipButtons} ${showTooltip === employee.id && cls.active}`}
                                            > 
                                            <a onClick={() => generateSingleLoginAndPassword(employee)}>{t('employeeManagement.generateLoginAndPasswordLabel')}</a>
                                            <a onClick={() => editData(employee)}>{t('employeeManagement.editDataLabel')}</a>
                                            <a onClick={() => deleteUser(employee)}>{t('employeeManagement.deleteEmployeeLabel')}</a>
                                        </div>
                                        <button onClick={() => showHandle(employee.id)}>
                                            <EditIcon />
                                        </button>
                                    </div>
                                </li>
                            ))
                        ) : (
                            <li className={`${cls.item} ${cls.itemLast}`}>
                                {t('employeeManagement.noEmployessLabel')}
                            </li>
                        )}
                    </ul>
                    </div>
                    {!loadMoreIsHide && <a className={cls.loadMore} onClick={showMoreEmployees}>{t('employeeManagement.loadMore')} <Arrow /></a>}
                </div>
            }
        </>
    );
};
